// A1 slope figures are a 3 m–5 m grid range: the USGS 1 m lidar averaged to 3 m and 5 m
// grids (docs/research/crownpine-siting-dossier/slope-grid-decision-2026-09-29.md). Single-value
// fields carry the 3 m figure, the conservative end; `carveOutAggregate.slopeGrid5m` and the
// `*_5m` keys on the A1 alternatives data carry the 5 m end. These helpers print the pair.

export const SLOPE_GRID_SOURCE = 'USGS 1 m lidar averaged to 3 m and 5 m grids';

const pair = (a: number, b: number): [number, number] => (a <= b ? [a, b] : [b, a]);
const join = (lo: string, hi: string) => (lo === hi ? lo : `${lo}–${hi}`);

/** Acres: nearest 10 from 100 up, else whole acres (the map labels use the same rule). */
const roundAc = (v: number) => (v >= 100 ? Math.round(v / 10) * 10 : Math.round(v));

export function acRange(a: number, b: number): string {
  const [lo, hi] = pair(Number(a), Number(b));
  return join(roundAc(lo).toLocaleString(), roundAc(hi).toLocaleString());
}

/** Shares under a threshold, whole percents: "69–74%". */
export function pctRange(a: number, b: number): string {
  const [lo, hi] = pair(Number(a), Number(b));
  return `${join(String(Math.round(lo)), String(Math.round(hi)))}%`;
}

/** Mean slope, one decimal: "4.1–4.6%". */
export function meanRange(a: number, b: number): string {
  const [lo, hi] = pair(Number(a), Number(b));
  return `${join(lo.toFixed(1), hi.toFixed(1))}%`;
}

// A range when the 5 m end is known; otherwise the single figure exactly as the page printed
// it before, so briefings other than A1 render unchanged.
export const acOr = (a: number, b?: number | null) => (b != null ? acRange(a, b) : Math.round(Number(a)).toLocaleString());
export const pctOr = (a: number, b?: number | null) => (b != null ? pctRange(a, b) : `${Math.round(Number(a))}%`);
export const meanOr = (a: number, b?: number | null) => (b != null ? meanRange(a, b) : `${Number(a).toFixed(2)}%`);

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

/** "2020-03-30" -> "March 30, 2020" (source publication dates in the method note). */
export function formatPublished(iso: string | null): string | null {
  const m = iso ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso) : null;
  return m ? `${MONTHS[Number(m[2]) - 1]} ${Number(m[3])}, ${m[1]}` : null;
}
